// Copyright © 2026 Neosocios - Seguimiento De Conversiones

document.addEventListener("DOMContentLoaded", function () {
  const trackingUpdated = sessionStorage.getItem("tracking_updated");

  if (trackingUpdated !== "true") {
    setTimeout(function () {
      function getURLParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name) || "";
      }

      function getCookie(name) {
        const match = document.cookie.match(
          new RegExp("(^| )" + name + "=([^;]+)")
        );
        return match ? match[2] : null;
      }

      function getGclidFromCookie() {
        const gclAw = getCookie("_gcl_aw");
        if (gclAw) {
          const parts = gclAw.split(".");
          return parts[parts.length - 1] || "";
        }
        return "";
      }

      const trackingData = {
        source: getURLParameter("utm_source"),
        medium: getURLParameter("utm_medium"),
        campaign: getURLParameter("utm_campaign"),
        term: getURLParameter("utm_term"),
        content: getURLParameter("utm_content"),
        fbp: getCookie("_fbp"),
        fbc: getCookie("_fbc"),
        ttp: getCookie("_ttp"),
        ttclid: getCookie("ttclid"),
        gclid: getGclidFromCookie(),
      };

      const attributes = {};

      attributes.Neosocios = "true";

      if (trackingData.source) attributes.Source = trackingData.source;
      if (trackingData.medium) attributes.Medium = trackingData.medium;
      if (trackingData.campaign) attributes.Campaign = trackingData.campaign;
      if (trackingData.term) attributes.Term = trackingData.term;
      if (trackingData.content) attributes.Content = trackingData.content;
      if (trackingData.fbp) attributes.fbp = trackingData.fbp;
      if (trackingData.fbc) attributes.fbc = trackingData.fbc;
      if (trackingData.ttp) attributes.ttp = trackingData.ttp;
      if (trackingData.ttclid) attributes.ttclid = trackingData.ttclid;
      if (trackingData.gclid) attributes.gclid = trackingData.gclid;

      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ attributes }),
      })
        .then((response) => {
          if (response.ok) {
            console.log("Neosocios: Cart attributes updated successfully");
            sessionStorage.setItem("tracking_updated", "true");
          }
          return response.json();
        })
        .then((data) => {
          console.log("Neosocios: Updated cart ", data);
        })
        .catch((error) => {
          console.error("Neosocios: Error updating cart attributes:", error);
        });
    }, 2000);
  }
});